import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllProductIdentityType = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [allProductIdentityType, setAllProductIdentityType] = useState([]);

  const getAllProductIdentityType = () => {
    setLoading(true);
    axiosClient
      .get(`Product/Branch/Packaging/Print/GetAllProductIdentityType`)
      .then(res => {
        if (res.status === 200) {
          // enqueueSnackbar(res.data?.message, { variant: 'success' });
          setAllProductIdentityType(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getAllProductIdentityType, loading, allProductIdentityType];
};

export default useGetAllProductIdentityType;
